import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

const r2 = (v) => Math.round((Number(v) || 0) * 100) / 100;
export const ROUTE = { magaza: "Depo → Mağaza", depo: "Mağaza → Depo" };

export const patchField = (id, field, value) => api.patch(`/products/${id}/field`, { field, value }).then((r) => r.data);
// Bölüm adedini düzelt (sayım) / bölümler arası aktar — her biri stok hareketi olarak kaydedilir
export const setLocQty = (p, loc, qty) => api.post("/stock/movements", { product_id: p.id, type: "sayim", location: loc, quantity: qty, note: "Stok Portalı · düzeltme" }).then((r) => r.data);
export const transfer = (p, to, qty) => api.post("/stock/movements", { product_id: p.id, type: "transfer", location: to, quantity: qty, note: `Stok Portalı · ${ROUTE[to]}` }).then((r) => r.data);
export const bulkTransfer = (ids, to, opts = {}) => api.post("/stock/bulk-transfer", { ids, to, ...opts }).then((r) => r.data);
export const undoMoves = (ids) => api.post("/stock/movements/undo-bulk", { ids }).then((r) => r.data);

export const applyMove = (p, m) => ({ ...p, quantity: r2(m.new_qty), qty_magaza: r2(m.new_mag), qty_depo: r2(m.new_qty - m.new_mag), value: r2(Math.max(m.new_qty, 0) * (p.cost || 0)) });

export function undoToast(msg, ids, onDone) {
  toast.success(msg, {
    duration: 9000,
    action: ids?.length ? {
      label: "Geri al",
      onClick: async () => {
        try { const r = await undoMoves(ids); toast.success(`${r.undone} hareket geri alındı`); onDone?.(); }
        catch (e) { toast.error(apiError(e)); }
      },
    } : undefined,
  });
}
